module.exports = __webpack_public_path__ + "static/media/grid.139d1ae4.svg";